export default {
    data() {
        return {
            yandexMetrikaReachGoalData: [
                'effectChatOpen',
                'effectChatClose',
                'effectChatStarted',
                'effectChatFinished'
            ]
        }
    },
    created() {
        if (!process.env.VUE_APP_YANDEX_METRIKA) return

        this.yandexMetrikaReachGoalData.forEach(item => {
            document.addEventListener(item, this.yandexMetrikaReachGoalSend)
        })
        this.$once('hook:beforeDestroy', () => {
            this.yandexMetrikaReachGoalData.forEach(item => {
                document.removeEventListener(item, this.yandexMetrikaReachGoalSend)
            })
        })
    },

    mounted() {},

    methods: {
        yandexMetrikaReachGoalSend({ type: reachGoal }) {
            if (reachGoal === 'effectChatOpen') {
                if (this.$store.state.api.login) reachGoal = 'Effect_openchat_authorized'
                else {
                    reachGoal = 'Effect_openchat_notauthorized'
                }
            }

            if (reachGoal === 'effectChatClose') {
                reachGoal = 'Effect_closechat'
            }
            if (reachGoal === 'effectChatStarted') {
                reachGoal = 'Effect_startchat_dialog'
            }
            if (reachGoal === 'effectChatFinished') {
                reachGoal = 'Effect_endchat_dialog'
            }

            if (this.$store.state.device.isMobileOnly) {
                reachGoal += '_mobile'
            }

            this.$nextTick(() => {
                if (this.$metrika) this.$metrika.reachGoal(reachGoal)
                else {
                    setTimeout(() => {
                        //при обновлении страницы $metrika null
                        if (this.$metrika) this.$metrika.reachGoal(reachGoal)
                    }, 5000)
                }
            })
        }
    }
}
